import { jsx } from 'react/jsx-runtime';
import { Checkbox } from '@fabric-app/ui/components/Checkbox/Checkbox';
import { reactToHTML } from '@fabric-app/ui/utils/reactToHTML';
import { Node, wrappingInputRule, mergeAttributes } from '@tiptap/core';

const inputRegex = /^\s*(\[([( |x])?\])\s$/;
const CheckboxRender = {
  checked: reactToHTML(/* @__PURE__ */ jsx(Checkbox.Default, {
    tabIndex: -1,
    checked: true
  })),
  unchecked: reactToHTML(/* @__PURE__ */ jsx(Checkbox.Default, {
    tabIndex: -1,
    checked: false
  }))
};
const FbcCheckList = Node.create({
  priority: 100,
  name: "fbcCheckList",
  content: "paragraph block*",
  group: "block list",
  defining: true,
  addAttributes() {
    return {
      checked: {
        default: false,
        keepOnSplit: false,
        parseHTML: (element) => {
          const dataChecked = element.getAttribute("data-checked");
          return dataChecked === "" || dataChecked === "true";
        },
        renderHTML: (attributes) => ({
          "data-checked": attributes.checked
        })
      }
    };
  },
  parseHTML() {
    return [
      {
        priority: 52,
        tag: "ul",
        skip: true
      },
      {
        tag: "li",
        priority: 52,
        getAttrs: (node) => {
          const closestList = node.closest("ol,ul");
          if (closestList && closestList.tagName === "ul" && (node.dataset.type === "fbc-check-list" || node.textContent?.match(/^\[(x|X| )\]/))) {
            return {
              ["data-type"]: "fbc-check-list"
            };
          }
          return false;
        }
      },
      {
        tag: 'div[data-type="fbc-check-list"]'
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return [
      "ul",
      mergeAttributes(HTMLAttributes, {
        "data-type": "fbc-check-list"
      }),
      [
        "li",
        [
          "label",
          [
            "input",
            {
              type: "checkbox",
              ...HTMLAttributes["data-checked"] ? {
                checked: true
              } : {}
            }
          ]
        ],
        [
          "div",
          0
        ]
      ]
    ];
  },
  addNodeView() {
    return ({ editor, node, getPos }) => {
      const { dom, contentDOM, updateRender, prefixContent } = renderFbcCheckList(node);
      const onClickPrefixContent = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (!editor.isEditable) return;
        const { view } = editor;
        const tr = view.state.tr;
        tr.setNodeMarkup(getPos(), void 0, {
          checked: !node.attrs.checked
        });
        view.dispatch(tr);
        updateRender();
      };
      prefixContent.addEventListener("click", onClickPrefixContent);
      return {
        dom,
        contentDOM,
        destroy: () => {
          prefixContent.removeEventListener("click", onClickPrefixContent);
        }
      };
    };
  },
  addInputRules() {
    return [
      wrappingInputRule({
        find: inputRegex,
        type: this.type,
        getAttributes: (match) => ({
          checked: match[match.length - 1] === "x"
        })
      })
    ];
  }
});
const renderFbcCheckList = (node) => {
  const dom = document.createElement("div");
  dom.classList.add("fbc-list");
  dom.dataset.type = "fbc-check-list";
  dom.dataset.checked = node.attrs.checked;
  dom.dataset.uuid = node.attrs["data-uuid"];
  dom.dataset.createdAt = node.attrs["data-created-at"];
  const prefix = document.createElement("div");
  prefix.classList.add("fbc-list-prefix");
  prefix.contentEditable = "false";
  prefix.style.height = "1.6em";
  const prefixContent = document.createElement("div");
  prefixContent.classList.add("fbc-list-prefix-content");
  prefixContent.innerHTML = CheckboxRender[node.attrs.checked ? "checked" : "unchecked"];
  prefix.appendChild(prefixContent);
  const content = document.createElement("div");
  content.classList.add("fbc-list-content");
  dom.append(prefix, content);
  const updateRender = () => {
    prefixContent.innerHTML = CheckboxRender[node.attrs.checked ? "checked" : "unchecked"];
    dom.dataset.checked = node.attrs.checked;
  };
  return {
    dom,
    contentDOM: content,
    updateRender,
    prefixContent
  };
};

export { FbcCheckList as default, inputRegex, renderFbcCheckList };
//# sourceMappingURL=FbcCheckList.js.map
